import { useTranslation } from 'react-i18next'
import { telHref } from '@/lib/format'
import { whatsappHref } from '@/lib/whatsapp'
import { LinkRow } from './LinkRow'
import './NotAvailable.css'

export interface ContactRowsProps {
  whatsapp: string | null
  phone: string | null
  reference: string
  /** Texto del mensaje de WhatsApp tras la referencia */
  message?: string
}

/**
 * Contacto con la propiedad cuando algo no se puede hacer desde la app: WhatsApp con la referencia y llamar. Sin
 * ninguno de los dos, dónde buscar el teléfono; nunca un contacto inventado (D51).
 */
export function ContactRows({ whatsapp, phone, reference, message }: ContactRowsProps) {
  const { t } = useTranslation()
  if (!whatsapp && !phone) return <p className="hp-notavailable__text">{t('v2.ayuda.sinContacto')}</p>
  return (
    <div className="hp-notavailable__rows">
      {whatsapp && <LinkRow icon="message-circle" title={t('v2.ds.contact.whatsapp')} subtitle={t('v2.ayuda.whatsappNota', { reference })} href={whatsappHref(whatsapp, reference, message)} />}
      {phone && <LinkRow icon="phone" title={t('v2.ds.contact.llamar')} subtitle={phone} href={telHref(phone)} tabular />}
    </div>
  )
}
